const tryParseJson = (value) => {
  if (!value || typeof value !== "string") return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const formatAiErrorMessage = (message, fallback = "Unable to complete the request.") => {
  if (!message || typeof message !== "string") return fallback;

  const trimmed = message.trim();
  const prefixMatch = trimmed.match(/^[^:]+:\s*(\{[\s\S]*\})$/);
  const jsonCandidate = prefixMatch?.[1] || (trimmed.startsWith("{") ? trimmed : null);
  const parsed = tryParseJson(jsonCandidate);

  if (parsed) {
    const inner =
      parsed?.error?.message ||
      parsed?.message ||
      (Array.isArray(parsed?.errors) ? parsed.errors.join(", ") : null);
    if (inner) return inner;
  }

  if (prefixMatch) {
    return trimmed.slice(0, prefixMatch.index).trim() || fallback;
  }

  return trimmed;
};

export const isAiApiSuccess = (response) => {
  if (!response || typeof response !== "object") return false;

  const success = response.success ?? response.Success;
  if (success === true) return true;
  if (success === false) return false;

  const statusCode = response.statusCode ?? response.StatusCode;
  if (typeof statusCode === "number") {
    if (statusCode >= 200 && statusCode < 300) return true;
    if (statusCode >= 400) return false;
  }

  // Encrypted / nested payloads sometimes drop the top-level success flag.
  const data = response.data ?? response.Data;
  if (data && typeof data === "object" && !Array.isArray(data)) {
    if ((data.isValid ?? data.IsValid) === true) return true;
    if (data.userPrompt || data.UserPrompt || data.systemPrompt || data.SystemPrompt) {
      return true;
    }
    if (data.parsedOutput != null || data.ParsedOutput != null) return true;
  }

  if (response.userPrompt || response.UserPrompt) return true;

  return false;
};

export const getAiApiMessage = (response, fallback = "") =>
  response?.message ?? response?.Message ?? fallback;

export const getAiValidationErrorMessage = (data, response, fallback) => {
  const errors =
    data?.validationErrors ||
    data?.ValidationErrors ||
    [];
  if (Array.isArray(errors) && errors.length) {
    return formatAiErrorMessage(errors.filter(Boolean).join(" "), fallback);
  }
  return formatAiErrorMessage(getAiApiMessage(response, fallback), fallback);
};
